export class DInDescription {
  number: number;
  description: string;
  department: string;

  constructor() {
    this.number = 0;
    this.description = "-- not in use --";
    this.department = "";
  }
}

export class DigitalInDescription {
  DI: DInDescription[];

  constructor() {
    this.DI = [];
  }
}
